import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Meeting from './Meeting';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '300px',
    minHeight: '250px',
    marginBottom: '30px',
    borderRadius: 'unset',
    padding: '20px',
    '& > h3': {
      fontSize: '14px',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    }
  }
}));

const Schedule = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <h3>Schedule meeting with investors</h3>
      <Meeting meeting="Meeting with BlackRock" time="March 15 - 14h00" />
      <Meeting meeting="Meeting with Praexo" time="April 04 - 10h00" />
    </Paper>
  );
};

export default Schedule;
